<template>
  <template v-if="formErrorMessage">
    <div
      class="mb-4 rounded-md bg-red-200 p-2 text-sm text-red-800"
    >
      <p class="">
        {{ formErrorMessage }}
      </p>
    </div>
  </template>
  <form class="space-y-6" novalidate @submit="onFormSubmit">
    <FormInputText
      name="email"
      type="email"
      autocomplete="email"
      label="Email Address"
    />

    <FormInputPassword
      name="password"
      label="Password"
      autocomplete="current-password"
    />

    <div class="flex items-center justify-between">
      <router-link
        :to="{ name: 'passwordResetRequest' }"
        class="text-sm text-primary hover:text-primary/70"
      >
        Forgot password?
      </router-link>

      <FormSubmitButton :is-loading="isSubmitting">
        Sign in with password
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import { z } from "zod"
import {
  emailAddressSchema,
  requiredNonBlankString,
} from "@/validation/sharedStringFieldSchemas"

const formErrorMessage = ref<string | null>(null)

const formSchema = z.object({
  email: emailAddressSchema("Email is required"),
  password: requiredNonBlankString("Password is required"),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    email: "",
    password: "",
  },
})

const onFormSubmit = handleSubmit(async (values) => {
  formErrorMessage.value = null
  try {
    await passwordLogIn(values)
    // ControlLogin will redirect user to home page. (this saves duplication as control login already needs to handle redirection in the case a user arrives already logged in)
  } catch {
    formErrorMessage.value =
      "Failed to log in. Please check your username and password are correct."
  }
})
</script>
